// extracted by mini-css-extract-plugin
module.exports = {"namePlate":"style-module__namePlate___ybdI3","icon":"style-module__icon___2n6R9","info":"style-module__info___1o2fv","headline":"style-module__headline___2CbyV"};